import React, { forwardRef } from "react";
import styles from "./style.module.css";
import { useTranslation } from "react-i18next";

const ImageInput = forwardRef(
  (
    {
      fileInfo,
      remark,
      label,
      errorMessage,
      exampleImageUrl,
      description,
      placeholder = "uploadPlaceholder",
      required = true,
      accept = "image/svg+xml, image/png, image/jpeg, image/gif, application/pdf",
      acceptMessage = "SVG, PNG, JPG, GIF or PDF",
      ...props
    },
    inputRef
  ) => {
    const { t } = useTranslation("loanProcessForm");

    const fileType = fileInfo?.file?.type;

    function handleTriggerFileInput(e) {
      e.stopPropagation();
      inputRef?.current?.click();
    }

    return (
      <div style={{ cursor: "pointer" }} className={styles.container}>
        {label && (
          <p className={styles.label}>
            {label}
            {required && <span style={{ color: "red" }}>*</span>}
          </p>
        )}
        {description && <p className={styles.description}>{t(description)}</p>}
        {exampleImageUrl && (
          <div className={styles.exampleImageContainer}>
            <p>{t("example")}</p>
            <img
              className={styles.imageContainer}
              src={exampleImageUrl}
              alt={t("exampleImageAlt")}
            />
          </div>
        )}
        <div
          onClick={handleTriggerFileInput}
          className={styles.borderContainer}
        >
          {fileInfo ? (
            <>
              {fileType === "application/pdf" ||
              fileInfo.base64.includes("application/pdf") ? (
                <div>
                  <img src="/assets/img/ci/icon/file-type-1.png" />
                  <p>{fileInfo.file.name}</p>
                </div>
              ) : fileType?.startsWith("image/") ? (
                <img
                  onClick={handleTriggerFileInput}
                  src={fileInfo.base64}
                  alt={t("selectedFile")}
                  className={styles.imageContainer}
                />
              ) : (
                <p>{t("unsupportedFile")}</p>
              )}
            </>
          ) : (
            <div className={styles.fileUpload} onClick={handleTriggerFileInput}>
              <img
                src="/assets/img/ci/icon/ico-upload.svg"
                alt={t("uploadIcon")}
              />
              <p>{t(placeholder)}</p>
              <p>
                {acceptMessage ||
                  accept
                    .split(",")
                    .map((type) => type.split("/")[1].toUpperCase())
                    .join(", ")}{" "}
              </p>
            </div>
          )}
        </div>
        {remark && <p className={styles.remark}>{t(remark)}</p>}
        {errorMessage && (
          <p className={styles.errorMessage}>{t(errorMessage)}</p>
        )}
        <input
          type="file"
          ref={inputRef}
          accept={accept}
          style={{ display: "none" }}
          {...props}
        />
      </div>
    );
  }
);

export default ImageInput;
